enum GenderType {
    NEUTRAL = 'nonSpecific',
    MALE = 'male',
    FEMALE = 'female',
}

export default GenderType;
